// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1h3DA","image":"Header_image__3h2Vy","name":"Header_name__1hYj3","info":"Header_info__1rLPf","infoRow":"Header_infoRow__1KhPC"};